{
  "schools": {
    "studentManagement": {
      "rosterSource": {
        "managedHint": "Managed by {connection}. Its roster keeps their name and year up to date.",
        "editHint": "Managed by {connection}. Its roster keeps this student’s name and year up to date.",
        "noGrade": "No year from {provider}"
      },
      "table": {
        "columns": {
          "year": "Year"
        },
        "filters": {
          "year": "Year"
        },
        "actions": {
          "removeConfirm": {
            "messageInvite": "Their invitation will be cancelled. You can re-invite them later."
          }
        }
      },
      "invite": {
        "fields": {
          "year": "Year (optional)",
          "gradePlaceholder": "Select year"
        }
      },
      "bulk": {
        "reasons": {
          "unknownYear": "Year isn't a valid option"
        }
      },
      "groups": {
        "fields": {
          "colour": "Group colour",
          "namePlaceholder": "e.g. 7MAT1, Reading Group A"
        },
        "subtitle": "Organise students into the groups you teach, like classes, small groups or cohorts. Groups are shared with all educators at {schoolName}.",
        "empty": "No groups yet. Create your first group to organise your roster.",
        "picker": {
          "capHint": "You can pick up to {limit} groups. Untick one to add another.",
          "createdAtCap": "{name} created. You can pick up to {limit} groups. Untick one to select it."
        },
        "members": {
          "subtitle": "{count} student in this group. Tick to add, untick to remove. | {count} students in this group. Tick to add, untick to remove."
        }
      },
      "actions": {
        "addOneStudentHint": "For a single student or a late enrolment"
      },
      "detail": {
        "progress": {
          "assignedTime": "set {age}"
        },
        "header": {
          "summaryNotOpened": "{count} not opened since it was set. | {count} not opened since they were set."
        },
        "gradeRequired": "Choose a year"
      }
    },
    "lessons": {
      "feedback": {
        "report": {
          "metrics": {
            "subjectEngagement": {
              "label": "Subject engagement",
              "caption": "More motivated to engage with this subject"
            },
            "connectToCareers": {
              "caption": "Better understood how this subject connects to real jobs"
            }
          }
        }
      },
      "builderCard": {
        "description": "Tell us the topic and who it's for. We'll pull the best matches from the catalogue below into a shareable lesson in about a minute."
      },
      "edit": {
        "picker": {
          "subtitle": "Pick from your published catalogue. Added topics appear at the bottom of your lesson."
        },
        "coverHint": "Optional — shown on your lesson card. We'll use a colour if you don't add one. JPEG, PNG or WebP."
      }
    },
    "lessonBuilder": {
      "briefPlaceholder": "e.g. An introduction to careers in renewable energy for Year 10 students.",
      "audiencePlaceholder": "e.g. Year 10 STEM students",
      "description": "Tell us the topic and who it’s for. We’ll pull the best matches from the catalogue below into a shareable lesson in about a minute."
    },
    "signup": {
      "form": {
        "emailPlaceholder": "name{'@'}school.edu.au"
      }
    },
    "leadersLanding": {
      "problem": {
        "description": "Counsellors cannot reach every student alone. The result is fragmented career education and too little usable data for leaders to prove - or improve - career readiness."
      },
      "schoolReview": {
        "items": {
          "responsibleAI": {
            "description": "Student personally identifiable information is not used to train AI models, and access to student information is limited according to roles and permissions."
          }
        }
      },
      "studentEngagement": {
        "description": "See how students are participating and responding across career-connected activities. Bring together signals on engagement, relevance, confidence, career interests and Career Development Plan progress to support planning, reporting, improvement and funding conversations."
      }
    },
    "auth": {
      "signInExpired": "That sign-in took too long. Enter your email to start again.",
      "chooseAccount": {
        "title": "Choose an account",
        "description": "Your email is linked to more than one school account. Pick the one to sign in to.",
        "personal": "Personal",
        "roles": {
          "teacher": "Teacher",
          "student": "Student",
          "admin": "Admin"
        },
        "submit": "Continue",
        "retry": "Try again"
      }
    },
    "accountSwitcher": {
      "trigger": "Switch account, signed in at {schoolName}",
      "errors": {
        "rateLimited": "Too many attempts. Please wait a few minutes and try again.",
        "failed": "We could not switch accounts. Please try again."
      }
    }
  }
}
